<template>
    <svg
        v-if="icon === 'arrow-left'"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor">
        <path
            fill-rule="evenodd"
            d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z"
            clip-rule="evenodd" />
    </svg>

    <svg
        v-else-if="icon === 'badge'"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M15 18C18.866 18 22 14.866 22 11C22 7.13401 18.866 4 15 4C11.134 4 8 7.13401 8 11C8 14.866 11.134 18 15 18Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M11.21 16.89L10 26L15 23L20 26L18.79 16.88"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>

    <svg
        v-else-if="icon === 'flash-warning'"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor">
        <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 10.5v3.75m-9.303 3.376C1.83 19.126 2.914 21 4.645 21h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 4.88c-.866-1.501-3.032-1.501-3.898 0L2.697 17.626zM12 17.25h.007v.008H12v-.008z" />
    </svg>

    <svg
        v-else-if="icon === 'flash-error'"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor">
        <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
    </svg>

    <svg
        v-else-if="icon === 'flash-success'"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor">
        <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>

    <svg
        v-else-if="icon === 'podium'"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15 6C15.5523 6 16 6.44772 16 7V23C16 23.5523 15.5523 24 15 24C14.4477 24 14 23.5523 14 23V7C14 6.44772 14.4477 6 15 6ZM21 12C21.5523 12 22 12.4477 22 13V23C22 23.5523 21.5523 24 21 24C20.4477 24 20 23.5523 20 23V13C20 12.4477 20.4477 12 21 12ZM10 17C10 16.4477 9.55228 16 9 16C8.44772 16 8 16.4477 8 17V23C8 23.5523 8.44772 24 9 24C9.55228 24 10 23.5523 10 23V17Z"
            fill="currentColor" />
    </svg>

    <svg
        v-else-if="icon === 'doc'"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M16 5H9C8.46957 5 7.96086 5.21071 7.58579 5.58579C7.21071 5.96086 7 6.46957 7 7V23C7 23.5304 7.21071 24.0391 7.58579 24.4142C7.96086 24.7893 8.46957 25 9 25H21C21.5304 25 22.0391 24.7893 22.4142 24.4142C22.7893 24.0391 23 23.5304 23 23V12L16 5Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M16 5V12H23"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>

    <svg
        v-else-if="icon === 'bell'"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M21 11C21 9.4087 20.3679 7.88258 19.2426 6.75736C18.1174 5.63214 16.5913 5 15 5C13.4087 5 11.8826 5.63214 10.7574 6.75736C9.63214 7.88258 9 9.4087 9 11C9 18 6 20 6 20H24C24 20 21 18 21 11Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M16.7295 24C16.5537 24.3031 16.3014 24.5547 15.9978 24.7295C15.6941 24.9044 15.3499 24.9965 14.9995 24.9965C14.6492 24.9965 14.3049 24.9044 14.0013 24.7295C13.6977 24.5547 13.4453 24.3031 13.2695 24"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>

    <svg
        v-else-if="icon === 'box'"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M24 18.9979V10.9979C23.9996 10.6472 23.9071 10.3028 23.7315 9.99911C23.556 9.69546 23.3037 9.44331 23 9.26795L16 5.26795C15.696 5.09241 15.3511 5 15 5C14.6489 5 14.304 5.09241 14 5.26795L7 9.26795C6.69626 9.44331 6.44398 9.69546 6.26846 9.99911C6.09294 10.3028 6.00036 10.6472 6 10.9979V18.9979C6.00036 19.3487 6.09294 19.6931 6.26846 19.9968C6.44398 20.3004 6.69626 20.5526 7 20.7279L14 24.7279C14.304 24.9035 14.6489 24.9959 15 24.9959C15.3511 24.9959 15.696 24.9035 16 24.7279L23 20.7279C23.3037 20.5526 23.556 20.3004 23.7315 19.9968C23.9071 19.6931 23.9996 19.3487 24 18.9979Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M6.27002 9.95795L15 15.0079L23.73 9.95795"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M15 25.078V14.998"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>

    <svg
        v-else-if="icon === 'flag'"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7 18C7 18 8 17 11 17C14 17 16 19 19 19C22 19 23 18 23 18V6C23 6 22 7 19 7C16 7 14 5 11 5C8 5 7 6 7 6V18Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M7 25V18"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>

    <svg
        v-else-if="icon === 'gear'"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M15 18C16.6569 18 18 16.6569 18 15C18 13.3431 16.6569 12 15 12C13.3431 12 12 13.3431 12 15C12 16.6569 13.3431 18 15 18Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M22.4 18C22.2669 18.3016 22.2272 18.6362 22.286 18.9606C22.3448 19.285 22.4995 19.5843 22.73 19.82L22.79 19.88C22.976 20.0657 23.1235 20.2863 23.2241 20.5291C23.3248 20.7719 23.3766 21.0322 23.3766 21.295C23.3766 21.5578 23.3248 21.8181 23.2241 22.0609C23.1235 22.3037 22.976 22.5243 22.79 22.71C22.6043 22.896 22.3837 23.0435 22.1409 23.1441C21.8981 23.2448 21.6378 23.2966 21.375 23.2966C21.1122 23.2966 20.8519 23.2448 20.6091 23.1441C20.3663 23.0435 20.1457 22.896 19.96 22.71L19.9 22.65C19.6643 22.4195 19.365 22.2648 19.0406 22.206C18.7162 22.1472 18.3816 22.1869 18.08 22.32C17.7842 22.4468 17.532 22.6572 17.3543 22.9255C17.1766 23.1938 17.0813 23.5082 17.08 23.83V24C17.08 24.5304 16.8693 25.0391 16.4942 25.4142C16.1191 25.7893 15.6104 26 15.08 26C14.5496 26 14.0409 25.7893 13.6658 25.4142C13.2907 25.0391 13.08 24.5304 13.08 24V23.91C13.0723 23.579 12.9651 23.258 12.7725 22.9887C12.5799 22.7194 12.3107 22.5143 12 22.4C11.6984 22.2669 11.3638 22.2272 11.0394 22.286C10.715 22.3448 10.4157 22.4995 10.18 22.73L10.12 22.79C9.93425 22.976 9.71368 23.1235 9.47088 23.2241C9.22808 23.3248 8.96783 23.3766 8.705 23.3766C8.44217 23.3766 8.18192 23.3248 7.93912 23.2241C7.69632 23.1235 7.47575 22.976 7.29 22.79C7.10405 22.6043 6.95653 22.3837 6.85588 22.1409C6.75523 21.8981 6.70343 21.6378 6.70343 21.375C6.70343 21.1122 6.75523 20.8519 6.85588 20.6091C6.95653 20.3663 7.10405 20.1457 7.29 19.96L7.35 19.9C7.58054 19.6643 7.73519 19.365 7.794 19.0406C7.85282 18.7162 7.81312 18.3816 7.68 18.08C7.55324 17.7842 7.34276 17.532 7.07447 17.3543C6.80618 17.1766 6.49179 17.0813 6.17 17.08H6C5.46957 17.08 4.96086 16.8693 4.58579 16.4942C4.21071 16.1191 4 15.6104 4 15.08C4 14.5496 4.21071 14.0409 4.58579 13.6658C4.96086 13.2907 5.46957 13.08 6 13.08H6.09C6.42099 13.0723 6.742 12.9651 7.0113 12.7725C7.28059 12.5799 7.48572 12.3107 7.6 12C7.73312 11.6984 7.77282 11.3638 7.714 11.0394C7.65519 10.715 7.50054 10.4157 7.27 10.18L7.21 10.12C7.02405 9.93425 6.87653 9.71368 6.77588 9.47088C6.67523 9.22808 6.62343 8.96783 6.62343 8.705C6.62343 8.44217 6.67523 8.18192 6.77588 7.93912C6.87653 7.69632 7.02405 7.47575 7.21 7.29C7.39575 7.10405 7.61632 6.95653 7.85912 6.85588C8.10192 6.75523 8.36217 6.70343 8.625 6.70343C8.88783 6.70343 9.14808 6.75523 9.39088 6.85588C9.63368 6.95653 9.85425 7.10405 10.04 7.29L10.1 7.35C10.3357 7.58054 10.635 7.73519 10.9594 7.794C11.2838 7.85282 11.6184 7.81312 11.92 7.68H12C12.2958 7.55324 12.548 7.34276 12.7257 7.07447C12.9034 6.80618 12.9987 6.49179 13 6.17V6C13 5.46957 13.2107 4.96086 13.5858 4.58579C13.9609 4.21071 14.4696 4 15 4C15.5304 4 16.0391 4.21071 16.4142 4.58579C16.7893 4.96086 17 5.46957 17 6V6.09C17.0013 6.41179 17.0966 6.72618 17.2743 6.99447C17.452 7.26276 17.7042 7.47324 18 7.6C18.3016 7.73312 18.6362 7.77282 18.9606 7.714C19.285 7.65519 19.5843 7.50054 19.82 7.27L19.88 7.21C20.0657 7.02405 20.2863 6.87653 20.5291 6.77588C20.7719 6.67523 21.0322 6.62343 21.295 6.62343C21.5578 6.62343 21.8181 6.67523 22.0609 6.77588C22.3037 6.87653 22.5243 7.02405 22.71 7.21C22.896 7.39575 23.0435 7.61632 23.1441 7.85912C23.2448 8.10192 23.2966 8.36217 23.2966 8.625C23.2966 8.88783 23.2448 9.14808 23.1441 9.39088C23.0435 9.63368 22.896 9.85425 22.71 10.04L22.65 10.1C22.4195 10.3357 22.2648 10.635 22.206 10.9594C22.1472 11.2838 22.1869 11.6184 22.32 11.92V12C22.4468 12.2958 22.6572 12.548 22.9255 12.7257C23.1938 12.9034 23.5082 12.9987 23.83 13H24C24.5304 13 25.0391 13.2107 25.4142 13.5858C25.7893 13.9609 26 14.4696 26 15C26 15.5304 25.7893 16.0391 25.4142 16.4142C25.0391 16.7893 24.5304 17 24 17H23.91C23.5882 17.0013 23.2738 17.0966 23.0055 17.2743C22.7372 17.452 22.5268 17.7042 22.4 18V18Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>

    <svg
        v-else-if="icon === 'home'"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6 12L15 5L24 12V23C24 23.5304 23.7893 24.0391 23.4142 24.4142C23.0391 24.7893 22.5304 25 22 25H8C7.46957 25 6.96086 24.7893 6.58579 24.4142C6.21071 24.0391 6 23.5304 6 23V12Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M12 25V15H18V25"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>

    <svg
        v-else-if="icon === 'list'"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11 9H24"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M11 15H24"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M11 21H24"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M6 9H6.01"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M6 15H6.01"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M6 21H6.01"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>

    <svg
        v-else-if="icon === 'logout'"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12 24H8C7.46957 24 6.96086 23.7893 6.58579 23.4142C6.21071 23.0391 6 22.5304 6 22V8C6 7.46957 6.21071 6.96086 6.58579 6.58579C6.96086 6.21071 7.46957 6 8 6H12"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M19 20L24 15L19 10"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M24 15H12"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>

    <svg
        v-else-if="icon === 'progress'"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M26 9L16.5 18.5L11.5 13.5L4 21"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M20 9H26V15"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>

    <svg
        v-else-if="icon === 'shop'"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12 25C12.5523 25 13 24.5523 13 24C13 23.4477 12.5523 23 12 23C11.4477 23 11 23.4477 11 24C11 24.5523 11.4477 25 12 25Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M23 25C23.5523 25 24 24.5523 24 24C24 23.4477 23.5523 23 23 23C22.4477 23 22 23.4477 22 24C22 24.5523 22.4477 25 23 25Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M4 4H8L10.68 17.39C10.7714 17.8504 11.0219 18.264 11.3875 18.5583C11.7532 18.8526 12.2107 19.009 12.68 19H22.4C22.8693 19.009 23.3268 18.8526 23.6925 18.5583C24.0581 18.264 24.3086 17.8504 24.4 17.39L26 9H9"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>

    <svg
        v-else-if="icon === 'users'"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M20 24V22C20 20.9391 19.5786 19.9217 18.8284 19.1716C18.0783 18.4214 17.0609 18 16 18H8C6.93913 18 5.92172 18.4214 5.17157 19.1716C4.42143 19.9217 4 20.9391 4 22V24"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M12 14C14.2091 14 16 12.2091 16 10C16 7.79086 14.2091 6 12 6C9.79086 6 8 7.79086 8 10C8 12.2091 9.79086 14 12 14Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M26 24V22C25.9993 21.1137 25.7044 20.2528 25.1614 19.5523C24.6184 18.8519 23.8581 18.3516 23 18.13"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M19 6.13C19.8604 6.35031 20.623 6.85071 21.1676 7.55232C21.7122 8.25392 22.0078 9.11683 22.0078 10.005C22.0078 10.8932 21.7122 11.7561 21.1676 12.4577C20.623 13.1593 19.8604 13.6597 19 13.88"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>

    <svg
        v-else-if="icon === 'chevron-right'"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor">
        <path
            fill-rule="evenodd"
            d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
            clip-rule="evenodd" />
    </svg>

    <svg
        v-else-if="icon === 'chevron-left'"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor">
        <path
            fill-rule="evenodd"
            d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
            clip-rule="evenodd" />
    </svg>
    <svg
        v-else-if="icon === 'upload'"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor">
        <path
            fill-rule="evenodd"
            d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM6.293 6.707a1 1 0 010-1.414l3-3a1 1 0 011.414 0l3 3a1 1 0 01-1.414 1.414L11 5.414V13a1 1 0 11-2 0V5.414L7.707 6.707a1 1 0 01-1.414 0z"
            clip-rule="evenodd" />
    </svg>
    <svg
        v-else-if="icon === 'cross'"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor">
        <path
            fill-rule="evenodd"
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            clip-rule="evenodd" />
    </svg>

    <svg
        v-else-if="icon === 'trash'"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6 9H8H24"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M22 9V23C22 23.5304 21.7893 24.0391 21.4142 24.4142C21.0391 24.7893 20.5304 25 20 25H10C9.46957 25 8.96086 24.7893 8.58579 24.4142C8.21071 24.0391 8 23.5304 8 23V9M11 9V7C11 6.46957 11.2107 5.96086 11.5858 5.58579C11.9609 5.21071 12.4696 5 13 5H17C17.5304 5 18.0391 5.21071 18.4142 5.58579C18.7893 5.96086 19 6.46957 19 7V9"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M13 14V20"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M17 14V20"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>

    <svg
        v-else-if="icon === 'check-circle'"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor">
        <path
            fill-rule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
            clip-rule="evenodd" />
    </svg>
    <svg
        v-else-if="icon === 'exclamation-circle'"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor">
        <path
            fill-rule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
            clip-rule="evenodd" />
    </svg>

    <svg
        v-else-if="icon === 'error-circle'"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor">
        <path
            fill-rule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
            clip-rule="evenodd" />
    </svg>

    <svg
        v-else-if="icon === 'sound'"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor">
        <path
            fill-rule="evenodd"
            d="M9.383 3.076A1 1 0 0110 4v12a1 1 0 01-1.707.707L4.586 13H2a1 1 0 01-1-1V8a1 1 0 011-1h2.586l3.707-3.707a1 1 0 011.09-.217zM14.657 2.929a1 1 0 011.414 0A9.972 9.972 0 0119 10a9.972 9.972 0 01-2.929 7.071 1 1 0 01-1.414-1.414A7.971 7.971 0 0017 10c0-2.21-.894-4.208-2.343-5.657a1 1 0 010-1.414zm-2.829 2.828a1 1 0 011.415 0A5.983 5.983 0 0115 10a5.984 5.984 0 01-1.757 4.243 1 1 0 01-1.415-1.415A3.984 3.984 0 0013 10a3.983 3.983 0 00-1.172-2.828 1 1 0 010-1.415z"
            clip-rule="evenodd" />
    </svg>

    <svg
        v-else-if="icon === 'caret'"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9 12L15 18L21 12"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>

    <svg
        v-else-if="icon === 'billing'"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M24 7H6C4.89543 7 4 7.89543 4 9V21C4 22.1046 4.89543 23 6 23H24C25.1046 23 26 22.1046 26 21V9C26 7.89543 25.1046 7 24 7Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M4 13H26"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>

    <svg
        v-else-if="icon === 'game-type-cards'"
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <rect
            x="11.1905"
            y="9.19052"
            width="17.2304"
            height="23.7675"
            rx="1.75119"
            stroke="currentColor"
            stroke-width="2.38104" />
        <rect
            x="19.8063"
            y="16.1714"
            width="19.6114"
            height="26.1486"
            rx="2.94172"
            fill="currentColor" />
    </svg>

    <svg
        v-else-if="icon === 'game-type-match'"
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M37.301 18.662C36.7339 19.2291 36.0277 19.5722 35.2922 19.6914L38.903 23.3022C40.0518 24.451 40.0518 26.3136 38.903 27.4624L35.2629 31.1026C35.1547 30.3415 34.808 29.6079 34.2226 29.0225C32.7866 27.5865 30.4583 27.5865 29.0223 29.0225C27.5863 30.4585 27.5863 32.7868 29.0223 34.2228C29.6077 34.8082 30.3413 35.1549 31.1024 35.2631L27.4624 38.903C26.3136 40.0518 24.451 40.0518 23.3022 38.903L19.6905 35.2913C19.5717 36.0278 19.2284 36.735 18.6606 37.3028C17.2246 38.7388 14.8964 38.7388 13.4604 37.3028C12.0244 35.8668 12.0244 33.5386 13.4604 32.1026C14.0282 31.5348 14.7354 31.1915 15.4719 31.0727L11.8616 27.4624C10.7128 26.3136 10.7128 24.451 11.8616 23.3022L15.5024 19.6614C15.6104 20.4227 15.9572 21.1566 16.5428 21.7421C17.9788 23.1782 20.307 23.1782 21.7431 21.7421C23.1791 20.3061 23.1791 17.9779 21.7431 16.5419C21.1575 15.9563 20.4236 15.6095 19.6623 15.5015L23.3022 11.8616C24.451 10.7128 26.3136 10.7128 27.4624 11.8616L31.0713 15.4705C31.1905 14.7351 31.5337 14.0288 32.1008 13.4617C33.5368 12.0257 35.865 12.0257 37.301 13.4617C38.7371 14.8977 38.7371 17.226 37.301 18.662Z"
            stroke="currentColor"
            stroke-width="2.38104"
            stroke-linejoin="round" />
    </svg>

    <svg
        v-else-if="icon === 'game-type-hear'"
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M23.2377 15.103L15.8834 20.9864H10V29.8116H15.8834L23.2377 35.695V15.103Z"
            stroke="currentColor"
            stroke-width="2.38104"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M35.1078 15C37.8652 17.7583 39.4142 21.4988 39.4142 25.399C39.4142 29.2992 37.8652 33.0397 35.1078 35.7979M29.9156 20.1921C31.2944 21.5713 32.0689 23.4415 32.0689 25.3916C32.0689 27.3417 31.2944 29.212 29.9156 30.5911"
            stroke="currentColor"
            stroke-width="2.38104"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>

    <svg
        v-else-if="icon === 'game-type-translate'"
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M32.5923 9L38.4757 14.8834L32.5923 20.7669"
            stroke="currentColor"
            stroke-width="2.38104"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M12 23.7086V20.7669C12 19.2065 12.6199 17.71 13.7232 16.6066C14.8266 15.5033 16.323 14.8834 17.8834 14.8834H38.4754"
            stroke="currentColor"
            stroke-width="2.38104"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M17.8834 41.3589L12 35.4754L17.8834 29.592"
            stroke="currentColor"
            stroke-width="2.38104"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M38.4754 26.6503V29.592C38.4754 31.1524 37.8556 32.6489 36.7522 33.7522C35.6489 34.8556 34.1524 35.4754 32.592 35.4754H12"
            stroke="currentColor"
            stroke-width="2.38104"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>

    <svg
        v-else-if="icon === 'game-type-battle'"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7 18C7 18 8 17 11 17C14 17 16 19 19 19C22 19 23 18 23 18V6C23 6 22 7 19 7C16 7 14 5 11 5C8 5 7 6 7 6V18Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M7 25V18"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>

    <svg
        v-else-if="icon === 'game-type-contest'"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M14.9589 19.2466C18.5607 19.2466 21.5343 16.2192 21.5343 12.6175V5H8.38365L8.38358 12.6175C8.38358 16.2192 11.3572 19.2466 14.9589 19.2466Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M8.38356 12.3973L8.38353 7.58317V5H4V8.2877C4 10.7534 5.64384 12.3973 8.38356 12.3973Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M21.5343 12.3973L21.5343 7.58317V5H25.9178V8.2877C25.9178 10.7534 24.274 12.3973 21.5343 12.3973Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M14.9589 19.2466V25M14.9589 25H10.5753M14.9589 25H19.3425"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>

    <svg
        v-else-if="icon === 'smiley'"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M15 25C20.5228 25 25 20.5228 25 15C25 9.47715 20.5228 5 15 5C9.47715 5 5 9.47715 5 15C5 20.5228 9.47715 25 15 25Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M11 18H19"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M12 12H12.01"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M18 12H18.01"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>

    <svg
        v-else-if="icon === 'thumb-up'"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10 25H7C6.46957 25 5.96086 24.7893 5.58579 24.4142C5.21071 24.0391 5 23.5304 5 23V16C5 15.4696 5.21071 14.9609 5.58579 14.5858C5.96086 14.2107 6.46957 14 7 14H10M17 12V8C17 7.20435 16.6839 6.44129 16.1213 5.87868C15.5587 5.31607 14.7956 5 14 5L10 14V25H21.28C21.7623 25.0055 22.2304 24.8364 22.5979 24.524C22.9654 24.2116 23.2077 23.7769 23.28 23.3L24.66 14.3C24.7035 14.0134 24.6842 13.7207 24.6033 13.4423C24.5225 13.1638 24.3821 12.9063 24.1919 12.6875C24.0016 12.4687 23.7661 12.2939 23.5016 12.1752C23.2371 12.0565 22.9499 11.9967 22.66 12H17Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>

    <svg
        v-else-if="icon === 'live-badge'"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M15 18C18.866 18 22 14.866 22 11C22 7.13401 18.866 4 15 4C11.134 4 8 7.13401 8 11C8 14.866 11.134 18 15 18Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M11.21 16.89L10 26L15 23L20 26L18.79 16.88"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>

    <svg
        v-else-if="icon === 'live-classroom'"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M20 24V22C20 20.9391 19.5786 19.9217 18.8284 19.1716C18.0783 18.4214 17.0609 18 16 18H8C6.93913 18 5.92172 18.4214 5.17157 19.1716C4.42143 19.9217 4 20.9391 4 22V24"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M12 14C14.2091 14 16 12.2091 16 10C16 7.79086 14.2091 6 12 6C9.79086 6 8 7.79086 8 10C8 12.2091 9.79086 14 12 14Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M26 23.9999V21.9999C25.9993 21.1136 25.7044 20.2527 25.1614 19.5522C24.6184 18.8517 23.8581 18.3515 23 18.1299"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M19 6.12988C19.8604 6.35018 20.623 6.85058 21.1676 7.55219C21.7122 8.2538 22.0078 9.11671 22.0078 10.0049C22.0078 10.8931 21.7122 11.756 21.1676 12.4576C20.623 13.1592 19.8604 13.6596 19 13.8799"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>

    <svg
        v-else-if="icon === 'live-random'"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M18 6H23V11"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M6 23L23 6"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M23 19V24H18"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M17 18L23 24"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M6 7L11 12"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>

    <svg
        v-else-if="icon === 'delete'"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M24 7H11L4 15L11 23H24C24.5304 23 25.0391 22.7893 25.4142 22.4142C25.7893 22.0391 26 21.5304 26 21V9C26 8.46957 25.7893 7.96086 25.4142 7.58579C25.0391 7.21071 24.5304 7 24 7V7Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M21 12L15 18"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M15 12L21 18"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>

    <svg
        v-else-if="icon === 'duplicate'"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor">
        <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 01-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 011.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 00-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 01-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5a3.375 3.375 0 00-3.375-3.375H9.75" />
    </svg>

    <svg
        v-else-if="icon === 'plus'"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M15 8V22"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M8 15H22"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>

    <svg
        v-else-if="icon === 'search'"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M14 22C18.4183 22 22 18.4183 22 14C22 9.58172 18.4183 6 14 6C9.58172 6 6 9.58172 6 14C6 18.4183 9.58172 22 14 22Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M24.0004 24.0004L19.6504 19.6504"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>

    <svg
        v-else-if="icon === 'edit'"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M14 7.12109H7C6.46957 7.12109 5.96086 7.33181 5.58579 7.70688C5.21071 8.08195 5 8.59066 5 9.12109V23.1211C5 23.6515 5.21071 24.1602 5.58579 24.5353C5.96086 24.9104 6.46957 25.1211 7 25.1211H21C21.5304 25.1211 22.0391 24.9104 22.4142 24.5353C22.7893 24.1602 23 23.6515 23 23.1211V16.1211"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M21.5 5.62132C21.8978 5.2235 22.4374 5 23 5C23.5626 5 24.1022 5.2235 24.5 5.62132C24.8978 6.01915 25.1213 6.55871 25.1213 7.12132C25.1213 7.68393 24.8978 8.2235 24.5 8.62132L15 18.1213L11 19.1213L12 15.1213L21.5 5.62132Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>

    <svg
        v-else-if="icon === 'menu'"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M24 15C24 15.5523 23.5523 16 23 16L7 16C6.44772 16 6 15.5523 6 15C6 14.4477 6.44772 14 7 14L23 14C23.5523 14 24 14.4477 24 15ZM18 21C18 21.5523 17.5523 22 17 22L7 22C6.44772 22 6 21.5523 6 21C6 20.4477 6.44772 20 7 20L17 20C17.5523 20 18 20.4477 18 21ZM13 10C13.5523 10 14 9.55228 14 9C14 8.44771 13.5523 8 13 8L7 8C6.44772 8 6 8.44771 6 9C6 9.55228 6.44772 10 7 10L13 10Z"
            fill="currentColor" />
    </svg>

    <span v-else> NOT {{ icon }} </span>
</template>

<script>
export default {
    name: "icons",
    props: {
        icon: {
            type: String,
            required: true
        }
    }
}
</script>
